import { wpApiInstance} from '../api/wp-api';

import { IUpdateUserSettings, IUpdateResponse } from '../models/settings.interface';
import { handleRouteError } from './route-helpers/route-error';

/**
 * Updates a user's settings using a WP api route.
 * 
 * @param user The user's settings to update
 * 
 * @returns Promise<IUpdateResponse>
 */
export const updateSettingsUser = async (user: IUpdateUserSettings): Promise<IUpdateResponse> => {
  try {
    const { data } = await wpApiInstance.post('/profile', { userData: user });

    return data;
  } catch (error) {
    handleRouteError(error, 'Error updating user data');
    throw error;
  }
}
